import { RootState } from 'app/rootReducer'

export const laneProposalsSelector = (state: RootState): LaneProposal[] =>
  Object.values(state.laneProposals.proposals)

export const laneProposalsIsLoadingSelector = (state: RootState): boolean =>
  state.laneProposals.meta.isLoading
